<template>
  <div class="relative">
    <div @click="toggle">
      <slot name="trigger"></slot>
    </div>
    <transition name="popover-fade">
      <div v-if="isOpen" v-click-outside="close" class="popover-panel">
        <div class="popover-arrow"></div>
        <div class="popover-header">
          <span class="popover-title">{{ title }}</span>
          <span class="popover-close" @click="close">&times;</span>
        </div>
        <div class="popover-body">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "PopoverPanel",

  props: {
    title: { type: String, default: "" },
    value: { type: Boolean, default: false },
  },

  computed: {
    isOpen: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
  },

  watch: {
    isOpen(val) {
      if (val) {
        window.addEventListener("scroll", this.onScroll, true);
      } else {
        window.removeEventListener("scroll", this.onScroll, true);
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll, true);
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    close() {
      this.isOpen = false;
    },
    onScroll(e) {
      // Ignorar scroll interno del popover body
      if (this.$el && this.$el.contains(e.target)) return;
      this.close();
    },
  },

  directives: {
    "click-outside": {
      bind(el, binding) {
        el._clickOutsideHandler = (e) => {
          if (!el.contains(e.target) && !el.parentElement.contains(e.target)) {
            binding.value();
          }
        };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      },
    },
  },
};
</script>

<style scoped>
.popover-panel {
  position: absolute;
  right: calc(100% + 16px);
  top: 50%;
  transform: translateY(-50%);
  width: 340px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ADC2EA;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(56, 93, 165, 0.25);
  z-index: 50;
}

.popover-arrow {
  position: absolute;
  right: -9px;
  top: 50%;
  transform: translateY(-50%) rotate(-45deg);
  width: 16px;
  height: 16px;
  background: #385DA5;
  z-index: 51;
}

.popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #385DA5;
  color: #fff;
  border-radius: 6px 6px 0 0;
  flex-shrink: 0;
}

.popover-title {
  font-size: 0.85rem;
  font-weight: 600;
}

.popover-close {
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  opacity: 0.8;
}

.popover-close:hover {
  opacity: 1;
}

.popover-body {
  padding: 12px;
  overflow-y: auto;
  flex: 1;
  background: #fff;
}

.popover-fade-enter-active,
.popover-fade-leave-active {
  transition: opacity 0.15s ease;
}

.popover-fade-enter,
.popover-fade-leave-to {
  opacity: 0;
}
</style>
